import { common } from '@mui/material/colors';
import { alpha } from '@mui/material/styles';
import { error, primary, white, black, lightgrey, lightred, darkgrey, grey, info, neutral, success, warning } from './colors';

export function createPalette() {
  return {
    action: {
      active: neutral[500],
      disabled: alpha(neutral[900], 0.38),
      disabledBackground: alpha(neutral[900], 0.12),
      focus: alpha(neutral[900], 0.16),
      hover: alpha(primary['main'], 0.14),
      selected: alpha(neutral[900], 0.12)
    },
    background: {
      default: common.white,
      paper: common.white
    },
    divider: '#F2F4F7',
    error,
    info,
    mode: 'light',
    neutral,
    primary: primary,
    secondary: black,
    white: white,
    lightgrey: lightgrey,
    lightred: lightred,
    darkgrey: darkgrey,
    grey: grey,
    success,
    text: {
      primary: neutral[900],
      secondary: neutral[500],
      disabled: alpha(neutral[900], 0.38)
    },
    warning
  };
}
